import React from "react";
import { Link } from "react-router-dom";
import { useMatch } from "react-router-dom";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import moment from "moment";
import { useState, useEffect, useContext } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import PaginationLayout from "../components/PaginationLayout";
import { getUserProfileImage } from "../utils/constant_value";

function CoinHistory({ userDetails }) {
  const { authState, currentUsd, scrollToTop } = useContext(GlobalContext);
  const match = useMatch("/user/:id/:page/:type");
  henceforthApi.setToken(authState?.access_token);
  const [loading, setLoading] = useState(false);
  const [totalCount , setTotalCount]=useState()
  const [page , setPage]=useState(0)
const limit=10;
  //Coin History
  const [getCoinHistorySend, setGetCoinHistorySend] = useState([]);
  const userDetailsCoinHistorySend = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsCoinHistorySend(
      match.params.id,
      _id
    );
    setGetCoinHistorySend(apiRes.data);
    setTotalCount(apiRes.count)
  };
  const [getCoinHistoryReceive, setGetCoinHistoryReceive] = useState([]);
  const userDetailsCoinHistoryReceive = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsCoinHistoryReceive(
      match?.params?.id,
      _id,
      page,limit
    );
    setGetCoinHistoryReceive(apiRes?.data);
  };
  const [getCoinHistoryPurchased, setGetCoinHistoryPurchased] = useState([]);
  const userDetailsCoinHistoryPurchased = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsCoinHistoryPurchased(
      match?.params?.id,
      _id,
      page,limit
    );
    setGetCoinHistoryPurchased(apiRes?.data);
  };

  const [getCoinHistoryWithdraw, setGetCoinHistoryWithdraw] = useState([]);
  const userDetailsCoinHistoryWithdraw = async (_id) => {
    let apiRes = await henceforthApi?.User?.getUserDetailsCoinHistoryWithdraw(
      match?.params?.id,
      _id
    );
    setGetCoinHistoryWithdraw(apiRes?.data);
  };
  const onChangePagination=(val)=>{
setPage(val)
  }

  useEffect(() => {
    userDetailsCoinHistorySend();
  }, [match?.params?.id, page]);

  return (
    <div>
      <div className="row chat-button">
        <ul
          class="nav nav-tabs border-0 post-like-comment mb-2"
          id="pills-tab"
          role="tablist"
        >
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              id="pills-home-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-home"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="true"
              onClick={() => userDetailsCoinHistorySend(userDetails?._id)}
            >
              Send
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-profile"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="false"
              onClick={() => userDetailsCoinHistoryReceive(userDetails?._id)}
            >
              Received
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pills-contact-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-contact"
              type="button"
              role="tab"
              aria-controls="pills-contact"
              aria-selected="false"
              onClick={() => userDetailsCoinHistoryPurchased(userDetails?._id)}
            >
              Purchased
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              class="nav-link"
              id="pills-withdraw-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-withdraw"
              type="button"
              role="tab"
              aria-controls="pills-withdraw"
              aria-selected="false"
              onClick={() => userDetailsCoinHistoryWithdraw(userDetails?._id)}
            >
              Withdraw
            </button>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div
            class="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <div
              class="tab-pane fade show active "
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="row">
                {getCoinHistorySend?.length ? getCoinHistorySend?.map((item, index) => (
                  <div className="col-sm-6" key={index}>
                    <div
                      className="modal-wrapper d-flex justify-content-between align-items-start"
                      style={{
                        border: "1px solid #E5E5E5E5",
                        borderRadius: "5px",
                        padding: "10px",
                        marginBottom: "10px",
                      }}
                    >
                      <div className="image-name-box d-flex gap-2 align-items-center">
                        <div className="image-box">
                          <img
                            src={getUserProfileImage(item?.reciever_id?.profile_pic)}
                            alt="ProfileImage"
                            class="modal-profile"
                          />
                        </div>
                        <div className="name-box">
                          <Link
                            to={`/user/${item?.reciever_id?._id}/1/1?type=posts`}
                            className="Details_of_User"
                          >
                            <p className="mb-0 profile-name">
                              {item?.reciever_id?.full_name}
                            </p>
                          </Link>
                          <p
                            className="m-0"
                            style={{
                              fontSize: "12px",
                            }}
                          >
                            {item?.reciever_id?.username}
                          </p>
                        </div>
                      </div>
                      <div className="price-date-box text-end">
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                            fontWeight: "bold",
                          }}
                        >
                          {" "}
                          <i
                            style={{
                              marginRight: "2px",
                              fontSize: "13px",
                            }}
                            class="fas fa-usd-circle"
                          ></i>{item?.coins}
                        </p>
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                        </p>
                      </div>
                    </div>
                  </div>
                )):<div className="text-center">No transaction found</div>}
              </div>
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <div className="row">
              {getCoinHistoryReceive?.length ? getCoinHistoryReceive?.map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <div
                    className="modal-wrapper d-flex justify-content-between align-items-start"
                    style={{
                      border: "1px solid #e5e5e5",
                      borderRadius: "5px",
                      padding: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div className="image-name-box d-flex gap-2 align-items-center">
                      <div className="image-box">
                        <img
                          src={
                            item?.sender_id?.profile_pic
                              ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${item?.sender_id?.profile_pic}`
                              : profile_placeholder
                          }
                          alt=""
                          class="modal-profile"
                        />
                      </div>
                      <div className="name-box">
                        <Link
                          to={`/user/${item?.sender_id?._id}/1/1?type=posts`}
                          className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">
                            {item?.sender_id?.full_name}
                          </p>
                        </Link>
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {item?.sender_id?.username}
                        </p>
                      </div>
                    </div>
                    <div className="price-date-box text-end">
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        <i
                          style={{
                            marginRight: "2px",
                            fontSize: "13px",
                          }}
                          class="fas fa-usd-circle"
                        ></i>{item?.coins}
                      </p>
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                      </p>
                    </div>
                  </div>
                </div>
              )): <div className="text-center">No transaction found</div>}
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-contact"
            role="tabpanel"
            aria-labelledby="pills-contact-tab"
          >
            <div className="row">
              {getCoinHistoryPurchased.length ? getCoinHistoryPurchased?.map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <div
                    className="modal-wrapper d-flex justify-content-between align-items-start"
                    style={{
                      border: "1px solid #e5e5e5",
                      borderRadius: "5px",
                      padding: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div className="image-name-box d-flex gap-2 align-items-center">
                      <div className="image-box">
                        <img
                          src={
                            item?.reciever_id?.profile_pic
                              ? `${henceforthApi?.API_FILE_ROOT_ORIGINAL}${item?.reciever_id?.profile_pic}`
                              : profile_placeholder
                          }
                          alt=""
                          class="modal-profile"
                        />
                      </div>

                      <div className="name-box">
                        <Link to={`/user/${item?._id}/1/1?type=posts`} className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">
                            {item?.reciever_id?.full_name}
                          </p>
                        </Link>
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {item?.coins} x <i
                            style={{
                              marginRight: "2px",
                              fontSize: "13px",
                            }}
                            class="fas fa-usd-circle"
                          ></i>1 =       <i
                            style={{
                              marginRight: "2px",
                              fontSize: "13px",
                            }}
                            class="fas fa-usd-circle"
                          ></i>{item?.coins}
                        </p>
                      </div>
                    </div>
                    <div className="price-date-box text-end">
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        <i
                          style={{
                            marginRight: "2px",
                            fontSize: "13px",
                          }}
                          class="fas fa-usd-circle"
                        ></i>

                        {item?.coins}
                      </p>
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                      </p>
                    </div>
                  </div>
                </div>
              )):<div className="text-center">No transaction found</div>}
            </div>
          </div>
          <div
            class="tab-pane fade"
            id="pills-withdraw"
            role="tabpanel"
            aria-labelledby="pills-withdraw-tab"
          >
            <div className="row">
              {getCoinHistoryWithdraw?.length ? getCoinHistoryWithdraw?.map((item, index) => (
                <div className="col-sm-6" key={index}>
                  <div
                    className="modal-wrapper d-flex justify-content-between align-items-start"
                    style={{
                      border: "1px solid #e5e5e5",
                      borderRadius: "5px",
                      padding: "10px",
                      marginBottom: "10px",
                    }}
                  >
                    <div className="image-name-box d-flex  align-items-center">
                      <div className="image-box">
                        <img
                          src={getUserProfileImage(item?.reciever_id?.profile_pic)}
                          alt=""
                          class="modal-profile"
                        />
                      </div>

                      <div className="name-box">
                        <Link
                          to={`/user/${item?._id}/1/1?type=posts`}
                          className="Details_of_User"
                        >
                          <p className="mb-0 profile-name">
                            {item?.reciever_id?.full_name}
                          </p>
                        </Link>
                        <p
                          className="m-0"
                          style={{
                            fontSize: "12px",
                          }}
                        >
                          {item.coins}x       <i
                            style={{
                              marginRight: "2px",
                              fontSize: "13px",
                            }}
                            class="fas fa-usd-circle"
                          ></i>1=       <i
                            style={{
                              marginRight: "2px",
                              fontSize: "13px",
                            }}
                            class="fas fa-usd-circle"
                          ></i>{item?.coins}
                        </p>
                      </div>
                    </div>
                    <div className="price-date-box text-end">
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {" "}
                        <i
                          style={{
                            marginRight: "2px",
                            fontSize: "13px",
                          }}
                          class="fas fa-usd-circle"
                        ></i>{item?.coins}
                      </p>
                      <p
                        className="m-0"
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {moment(Number(item?.created_at)).format("DD MMM YYYY, h:mm a")}
                      </p>
                    </div>
                  </div>
                  {/* <hr /> */}

                  {/* <hr /> */}
                </div>
              )) :<div className="text-center">No transaction found</div>}
            </div>
          </div>
        </div>
      </div>
      {/* <PaginationLayout
              count={totalCount}
              data={getCoinHistorySend}
              page={page}
              limit={limit}
              loading={loading}
              onPageChange={(val) => onChangePagination(val)}
            /> */}
    </div>
  );
}

export default CoinHistory;
